
import ScheduleInterface from '@/interfaces/Schedule.interface';
import { ScheduleService } from './schedule.service';
import UserService from '@/views/Users/user.service';
import { ComputerService } from '../Computers/computer.service';
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { ToastFactory } from '@/utils/ToastFactory';
import dayjs from 'dayjs';
import { asRoughMinutes } from '@fullcalendar/core/internal';
import moment from 'moment';
const scheduleService = new ScheduleService();
const userService = new UserService();
const computerService = new ComputerService();

export default defineComponent({
    name: 'AddSchedule',
    data(){
        return{
            scheduleId: "" as string,
            form:{
                schedule: {
                    calendarList: [{
                        checkIn: "" as string,
                        checkOut: "" as string,
                        daysWeek: [],
                    }] as any,
                    userId: "" as string,
                    initDate: "" as string,
                    finishDate: "" as string,
                } as ScheduleInterface
            },
            navigator: window.navigator.language,
            selectedDays: [] as any,
            noDaysSelected: false as boolean,
            disabled: false as boolean,
            hasChanged: false as boolean,
            pickedUser: "" as any,
            pickedComputer: "" as any,
            users: [] as any,
            computers: [] as any,
            params: { page: 0, size: 10 },
            paramsUser: { name: "", page: 0, size: 10 },
            weekDays:[
            {name:'domingo', label: 'D', enLabel:'Su', value: 0},
            {name:'segunda', label: 'S', enLabel:'M', value: 1},
            {name:'terça', label: 'T', enLabel:'T', value: 2},
            {name:'quarta', label: 'Q', enLabel:'W', value: 3},
            {name:'quinta', label: 'Q', enLabel:'T', value: 4},
            {name:'sexta', label: 'S', enLabel:'F', value: 5},
            {name:'sabado', label: 'S', enLabel:'Sa', value: 6}
            ],
        }
    },

    watch:{
        'form.schedule.initDate': {
            handler: function (val, oldVal) {
                if(oldVal != ""){
                    this.hasChanged = true;
                }
            },
            deep: true
        },
        'form.schedule.finishDate': {
            handler: function (val, oldVal) {
                if(oldVal != ""){
                    this.hasChanged = true;
                }
            },
            deep: true
        },
        'form.group.calendarList': {
            handler(val, oldVal) {
                if(oldVal[0].checkIn.length > 0 || oldVal[0].checkOut.length > 0){
                    this.hasChanged = true;
                }
            },
            deep: true
        },
        selectedDays:{
            handler: function (val, oldVal) {
                if(oldVal.length > 0){
                        this.hasChanged = true;
                    }
                if(val > 0){
                    this.noDaysSelected = false;
                }
            },
            deep: true
        }
    },

    setup(){
        return{
            v$: useVuelidate()
        }
    },

    validations(){
        return{
            selectedDays:{required},
            form:{
                schedule:{
                    calendarList:[{
                        checkIn: { required },
                        checkOut: { required },
                    }],
                    userId: { required },
                    initDate: { required },
                    finishDate: { required },
                }
            }
        }
    },

    computed: {
        ...mapGetters({
            storeSchedule: 'schedule/getScheduleId',
            storeUsers: 'users/getUsers',
            userSchedule: 'users/getUser',
        })
    },

    methods: {
        async getScheduleById(){
            await scheduleService.getScheduleById(this.scheduleId).then(() => {
                this.form.schedule = this.storeSchedule;
                this.form.schedule.initDate = dayjs(this.storeSchedule.createdAT).format('DD/MM/YYYY');
                this.form.schedule.finishDate = dayjs(this.storeSchedule.dateFinish).format('DD/MM/YYYY');
                this.selectedDays = this.form.schedule.calendarList[0].daysWeek.map((day: any) => day.day);
                this.getUserId();
            });
        },
        
        getUser(event: any){
            this.paramsUser.name = event.query;
            userService.getAllUsers(this.params).then(() => {
                this.users = this.storeUsers.content;
            });
        },

        getUserId() {
            userService.getUserById(this.form.schedule.user?.id).then(() => {
                this.pickedUser = this.userSchedule;
            });
        },

        confirmDelete(id: any) {
            id ? this.$confirm.require({
                    header: this.$t('schedule.delete'),
                    message: this.$t('schedule.confirmDelete'),
                    accept: () => this.deleteSchedule(),
                    reject: () => { },
                }) : this.$confirm.require({
                    header: this.$t('schedule.delete'),
                    message: this.$t('schedule.confirmDelete'),
                    accept: () => this.$router.push({ name: 'Schedule' }),
                    reject: () => { },
                });     
        },

        deleteSchedule(){
            scheduleService.deleteSchedule(this.scheduleId).then(() => {
                this.$toast.add(ToastFactory.success(this.$t('toast.sucessScheduleDelete')))
                this.$router.push({ name: 'Schedule' });
            }).catch((e) => {
                this.$toast.add(ToastFactory.error(this.$t('schedule.errorScheduleDelete')))
            });
        },

        confirmChanges(schedule: any){
            if(this.hasChanged){
                this.$confirm.require({
                    header: 'Editar alocação',
                    message: 'Mudanças foram realizadas nessa reserva. Ao confirmar, todas as alocações desse usuário ou cliente serão deletadas. Deseja continuar?',
                    accept: () => this.updateSchedule(schedule),
                })
            } else {
                this.updateSchedule(schedule);
            }
        },

        addSchedule(data: ScheduleInterface): void{
            this.form.schedule.initDate = dayjs(this.form.schedule.initDate).format("YYYY-MM-DD");
            this.form.schedule.finishDate = dayjs(this.form.schedule.finishDate).format("YYYY-MM-DD");
            this.form.schedule.calendarList[0].checkIn = moment(this.form.schedule.calendarList[0].checkIn).format("HH:mm:ss");
            this.form.schedule.calendarList[0].checkOut = moment(this.form.schedule.calendarList[0].checkOut).format("HH:mm:ss");

            scheduleService.addSchedule(data)
            .then(() => {
                this.$toast.add(ToastFactory.success('Agendamento cadastrado com sucesso!'))
                this.$router.push({ name: 'Schedule' });
            }).catch((e) => {
                this.$toast.add(ToastFactory.error(this.codeError(e.response.data.code)))
            });
        },

        updateSchedule(data: ScheduleInterface): void{
            this.form.schedule.initDate = moment(this.form.schedule.initDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
            this.form.schedule.finishDate = moment(this.form.schedule.finishDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
            this.form.schedule.calendarList[0].checkIn = dayjs(this.form.schedule.calendarList[0].checkIn).format("HH:mm:ss");
            this.form.schedule.calendarList[0].checkOut = dayjs(this.form.schedule.calendarList[0].checkOut).format("HH:mm:ss");

            scheduleService.updateSchedule(this.scheduleId, this.form.schedule)
            .then(() => {
                this.$toast.add(ToastFactory.success('Agendamento atualizado com sucesso!'))
                this.$router.push({ name: 'Schedule' });
            }).catch((e) => {
                console.log(e.message);
                this.$toast.add(ToastFactory.error('Erro ao atualizar agendamento!'))
            });
        },

        codeError(error: any): string{
            switch(error){
                case "COMPUTER_AMOUNT":
                    return this.$t('errors.computerAmount');
                default:
                    return this.$t('errors.defaultError');
            }
        },

        sendSchedule(): void{
            this.v$.form.$touch();
            this.form.schedule.userId = this.pickedUser.id;

            if(this.selectedDays == null || this.selectedDays.length == 0){
                this.noDaysSelected = true;
            }
            
            if(!this.v$.form.$invalid){
                this.form.schedule.calendarList[0].daysWeek = this.selectedDays;
                this.form.schedule.recurrence = true;
                this.scheduleId ? this.$router.push({name: 'Schedule'}) : this.addSchedule(this.form.schedule);
            }
        }
    },

    mounted(){
        this.scheduleId = this.$route?.params?.id as string;
        this.scheduleId ? this.getScheduleById() : null;
        this.scheduleId ? this.disabled = true : null;
    }
});
